export const LOGOUT_ERROR_KEY = 'logout_error';
export const BOND_USER_ID_TOKEN_COOKIE = 'BondUserIdToken';
